var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_728_21620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#8E54CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9541 17.2203C31.9844 16.8175 31.9999 16.4105 31.9999 16C31.9999 15.7403 31.9937 15.482 31.9815 15.2254L21.7142 8.12695L10.2856 25.8412L19.5489 31.6051C25.079 30.3526 29.5222 26.2359 31.2368 20.8966L31.238 20.8889L31.492 20L31.7438 18.8666C31.7453 18.8584 31.7469 18.85 31.7484 18.8417L31.8682 18.0621C31.8709 18.0417 31.8735 18.0213 31.876 18.0009L31.9541 17.2203Z",
    fill: "#834DBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0635 11.3008H16.127V22.8563H20.0635V11.3008Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.127 11.3008H11.9365V22.7294H16.127V11.3008Z",
    fill: "#F0F0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.127 25.9047H21.7143V8.12695H16.127V25.9047ZM20.1367 22.6724H16.127V11.3593H20.1367V22.6724Z",
    fill: "#3C4F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1271 25.9047H10.5398V8.12695H16.1271V25.9047ZM12.1173 22.6724H16.1271V11.3593H12.1173V22.6724Z",
    fill: "#54698E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.127 12.3184H14.0952V16.3819H16.127V12.3184Z",
    fill: "#28B3E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.127 17.6504H14.0952V21.7139H16.127V17.6504Z",
    fill: "#28B3E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1587 12.3184H16.127V16.3819H18.1587V12.3184Z",
    fill: "#0090FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1587 17.6504H16.127V21.7139H18.1587V17.6504Z",
    fill: "#0090FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1269 13.5879H15.238V15.2387H16.1269V13.5879Z",
    fill: "#F0F0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1269 18.793H15.238V20.4438H16.1269V18.793Z",
    fill: "#F0F0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8889 13.5879H16.127V15.2387H16.8889V13.5879Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8889 18.793H16.127V20.4438H16.8889V18.793Z",
    fill: "#E8E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_728_21620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductAppIcon);
export default __webpack_public_path__ + "static/media/product_app_icon.4dec7b74626cd0c3d5aeed38f04aad34.svg";
export { ForwardRef as ReactComponent };